module.exports = __webpack_public_path__ + "static/dietcola-d2412c06ef3f72da9a4641ddc2113ee0.jpg";